import i18next from 'i18next';
import tr from './tr';

i18next.init({
  lng: localStorage.getItem('lang') || 'tr', // if you"re using a language detector, do not define the lng option
  debug: true,
  resources: {
    tr: tr,
  },
  // languages:['ger','tr']
});
// initialized and ready to go!
// i18next is already initialized, because the translation resources where passed via init function

export default i18next;
